import { EMBED_RESOURCE_TYPE_NAME } from './constants.js';

const findNode = (view, uuid) => {
  let found = null;
  view.state.doc.descendants((node, pos) => {
    if (node.attrs["data-uuid"] === uuid && node.type.name === EMBED_RESOURCE_TYPE_NAME) {
      found = {
        node,
        pos
      };
    }
    if (found) return false;
  });
  return found;
};
const updateNodeAttributesWithResourceDetail = (view, uuid, resource) => {
  return updateNodeAttributes(view, uuid, {
    src: resource.thumbnail?.lg || resource.fileUrl,
    resourceId: resource.id,
    parentResourceId: resource.parent?.id,
    loading: false,
    mimeType: resource.mimeType,
    kind: resource.kind,
    uploadProgress: null,
    extension: resource.extension,
    alt: resource.name,
    title: resource.name
  });
};
const updateNodeAttributes = (view, uuid, nextAttributes) => {
  const foundNode = findNode(view, uuid);
  if (!foundNode) return;
  const { node: { attrs, type }, pos: newPos } = foundNode;
  const updateTransaction = view.state.tr.setNodeMarkup(newPos, type, {
    ...attrs,
    ...nextAttributes
  }, []);
  view.dispatch(updateTransaction);
};

export { updateNodeAttributes, updateNodeAttributesWithResourceDetail };
//# sourceMappingURL=utils.js.map
